import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@src/environments/environment';
import { CustomerUser } from '@src/app/models/customeruser';

@Injectable({
  providedIn: 'root'
})
export class CustomerusercreateService {
  // /organization/{organizationId}/customer/{customerId}/user/{userId}
  constructor(private http:HttpClient) { }

  addCustomerUser(customerUser:CustomerUser){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post<string>(environment.apiUrl+
      '/organization/'+SessionHelper.getChoosenOrg()+'/customer/'+
      customerUser.customerId+
      '/user',JSON.stringify(customerUser),httpOptions);
  }
}
